import React from "react";
import { NavLink } from "react-router-dom";
import type { Category } from "../../utils/api/category/category.type";
import SubCategoriesModal from "./items/SubCategoriesModal";
import ProductsModal from "./items/ProductsModal";

type CategoryCardAsBestSellerProps = {
  item: Category;
  imageSrc: string;
};

/**
 * Carte catégorie = même gabarit visuel que `BestSellerCard` / doc YEKSINA §1
 * (zone image 70 %, corps, titre centré — sans prix ni actions).
 */
const CategoryCardAsBestSeller = ({
  item,
  imageSrc,
}: CategoryCardAsBestSellerProps) => {
  const [showSubCategories, setShowSubCategories] = React.useState(false);
  const [showProducts, setShowProducts] = React.useState(false);
  const to = `/produits?categorie=${item?.slug}`;
  const state = { catgoryId: item?.id };

  const isMobileViewport = () =>
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 991px)").matches;

  const handleCategoryClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isMobileViewport()) return;

    event.preventDefault();
    if (item?.sous_categorie?.length > 0) {
      setShowSubCategories(true);
      return;
    }
    setShowProducts(true);
  };

  return (
    <>
      <div className="best-seller-card best-seller-card--category">
        <div className="best-seller-card-link">
          <div className="best-seller-card-image-wrapper">
            <NavLink
              to={to}
              state={state}
              className="best-seller-card-image-link"
              onClick={handleCategoryClick}
            >
              <img
                className="best-seller-card-image"
                src={imageSrc}
                alt={item?.nom ?? ""}
                loading="lazy"
              />
            </NavLink>
          </div>
          <div className="best-seller-card-body best-seller-card-body--category-only">
            <NavLink
              to={to}
              state={state}
              className="best-seller-card-name-link"
              onClick={handleCategoryClick}
            >
              <h4 className="best-seller-card-name">{item?.nom}</h4>
            </NavLink>
          </div>
        </div>
      </div>
      <SubCategoriesModal
        show={showSubCategories}
        handleClose={() => setShowSubCategories(false)}
        category={item}
      />
      <ProductsModal
        show={showProducts}
        handleClose={() => setShowProducts(false)}
        category={item}
      />
    </>
  );
};

export default CategoryCardAsBestSeller;
